/*eslint-disable*/
import { NavBar } from 'components/NavBar/NavBar'
import { getSingleDBTask } from 'features/dashboard/dbTasksSlice'
import { IMachineTask, IUserTaskTemplate } from 'features/dashboard/types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Animation, Flex, H1WithBack, PageControls, PageWrapper, Separator } from 'styling/GlobalStyles'
import { formatDateForDisplay, getTime, getTimeFromDate } from 'utils/helpers'
import { taskStatusesData } from '../dashboardData'
import { DBSingleTaskContainer, DBSingleTaskSection, DBTaskDetailsCard, DBTaskGrid, DBTaskGridCard, DBTaskLongCard, DBTaskStatus, DBTaskTimelineItem, DBTimelineLogContainer, DBTimelineTitle, TimelineLineContainer, TimelineLog } from './DBTasks.styled'
import { LocationIcon } from 'assets/icons/LocationIcon'
import { TruckIcon } from 'assets/icons/TruckIcon'
import { EmployeesIconBlank } from 'assets/icons/EmployeesIconBlank'
import { ImagesSlider } from 'components/ImagesSlider/ImagesSlider'
import { BodyText, OtherText, TitleText } from 'styling/Typography'

interface ITimelineItem {
    data: IUserTaskTemplate | IMachineTask
    handleImages: any
    ifFirst?: boolean
    ref?: any
}
export const TimelineItem = ({ data, handleImages, ifFirst, ref }: ITimelineItem) => {
    const [open, setOpen] = useState(ifFirst)
    const StatusIcon = taskStatusesData.find(s => s.id == data.status).icon as any
    return <DBTaskTimelineItem ref={ref} onClick={() => setOpen(prev => !prev)} >
        <DBTimelineTitle status={data.status} >
            <Flex column gap='8px' alignStart >
                <BodyText weight='bold'>{'executionPlans' in data ? (data.user.firstName + ' ' + data.user.lastName) : data.name}</BodyText>
                {open && <>
                    <OtherText>{data.user.role?.name}</OtherText>
                    {!('executionPlans' in data) && <OtherText>{(data.user.firstName + ' ' + data.user.lastName)}</OtherText>}
                    {data.estimatedStartDate && <OtherText>{`Estimation Time: ${formatDateForDisplay(data.estimatedStartDate) + ' ' + getTimeFromDate(data?.estimatedStartDate)} - ${formatDateForDisplay(data?.estimatedEndDate) + ' ' + getTimeFromDate(data?.estimatedEndDate)}`}</OtherText>}
                    {'executionPlans' in data && <OtherText>{`Machine: ${data.executionPlans[0]?.machine?.name ?? '-'}`}</OtherText>}
                </>}
            </Flex>
            {StatusIcon}
        </DBTimelineTitle>
        <DBTimelineLogContainer open={open} onClick={e => e.stopPropagation()} >
            <TimelineLineContainer>
                {
                    data.executions.map((e, i) => <TimelineLog key={i} >
                        <OtherText style={{ width: 100 }} >{formatDateForDisplay(e.from, true)} <br /> {getTimeFromDate(e.from)}</OtherText>
                        <div className='svg' >
                            <svg width='30' height='50' xmlns='http://www.w3.org/2000/svg' overflow='visible' >
                                {!(e.status == 3 || e.status == 7) && <line x1='10' y1='15' x2='10' y2='60' stroke='orange' strokeWidth='3' />}
                                <circle cx='10' cy='10' r='7' fill='orange' strokeWidth='3' />
                                <circle cx='10' cy='10' r='3' fill='white' />
                            </svg>
                        </div>
                        <Flex column >
                            {/* @ts-ignore */}
                            <BodyText className='task-status' >{taskStatusesData.find(s => s.id == e.status).name} <span style={{ color: 'red' }} >{e.status == 4 && (e.userTaskExecutionIssue?.issueTrigger?.issue?.name || e.executionIssue?.issueTrigger?.issue?.name)}</span></BodyText>
                            {((e.status == 3 && e.completedImageUrls.length > 0) || (e.status !== 3 && e.reportedImageUrls.length > 0)) &&
                                <BodyText className='view-image' onClick={() => handleImages(e.status == 3 ? e.completedImageUrls : e.reportedImageUrls, e.userTaskExecutionIssue?.description)}>View Image</BodyText>}
                        </Flex>
                    </TimelineLog>
                    )
                }
            </TimelineLineContainer>
        </DBTimelineLogContainer>
    </DBTaskTimelineItem>
}

export const DBSingleTask = () => {

    const dispatch = useDispatch<AppDispatch>()
    const { id } = useParams()
    const [imagesModal, setImagesModal] = useState({ open: false, images: [], details: '' })
    const { singleDBTask } = useSelector((state: RootState) => state.dbTasks)
    const fromTasks = (new URLSearchParams(location.search).get('fromTasks'))


    useEffect(() => {
        dispatch(getSingleDBTask(id))
    }, [id])

    const getMachines = () => {
        const machines = []
        if (singleDBTask) {
            for (const ut of singleDBTask?.userTasks) {
                for (const m of ut?.executionPlans) {
                    m.machine?.name && machines.push(m.machine?.name)
                }
            }
        }
        return machines
    }

    const Status = ({ st }: { st?: number }) => {
        const status = taskStatusesData.find(s => s.id == (st ?? singleDBTask?.status))
        return <DBTaskStatus status={singleDBTask?.status} >
            <div className='svg' >
                {status.icon}
            </div>
            {!st && <BodyText>{status.name}</BodyText>}
        </DBTaskStatus>
    }

    const handleImages = (images: string[], details: string) => {
        setImagesModal(prev => {
            const copy = structuredClone(prev)
            copy.images = images
            copy.details = details
            copy.open = true
            return copy
        })
    }

    return <>
        <NavBar />
        <Animation>
            <PageWrapper noFooter>
                <PageControls >
                    <H1WithBack link={fromTasks ? '/tasks' : null} arrow title={singleDBTask?.cycleInfo ? singleDBTask.cycleInfo.templateStep.name : singleDBTask?.taskTemplate ? singleDBTask?.taskTemplate?.name : singleDBTask?.processInfo?.name} />
                    {Number.isInteger(singleDBTask?.status) && <Status />}
                </PageControls>
                <DBSingleTaskContainer>
                    <DBSingleTaskSection style={{ width: '60%' }} >
                        <TitleText weight='bold'>General Info</TitleText>
                        <DBTaskLongCard>
                            <div className='wrapper'>
                                <TitleText weight='bold'>TASK DETAILS</TitleText>
                                <Flex gap='1rem' between >
                                    <DBTaskDetailsCard>
                                        {LocationIcon}
                                        <BodyText weight='bold'>Location: </BodyText>
                                        <OtherText>{singleDBTask?.location.name}</OtherText>
                                    </DBTaskDetailsCard>
                                    <DBTaskDetailsCard>
                                        {TruckIcon}
                                        <BodyText weight='bold'>Machines: </BodyText>
                                        <OtherText>{getMachines().length}</OtherText>
                                    </DBTaskDetailsCard>
                                    <DBTaskDetailsCard>
                                        {EmployeesIconBlank}
                                        <BodyText weight='bold'>Employees: </BodyText>
                                        <OtherText>{singleDBTask?.userTasks.length}</OtherText>
                                    </DBTaskDetailsCard>
                                </Flex>
                            </div>

                        </DBTaskLongCard>
                        <DBTaskGrid>
                            <DBTaskGridCard>
                                <BodyText weight='bold'>Estimated Time</BodyText>
                                <Separator />
                                <Flex gap='10px' column between >
                                    <div>
                                        <BodyText weight='bold'>Estimated start date:</BodyText>
                                        <OtherText>{singleDBTask?.estimatedCost ?
                                            (formatDateForDisplay(singleDBTask?.estimatedStartDate) + ' ' + getTimeFromDate(singleDBTask?.estimatedStartDate))
                                            : '-'} </OtherText>
                                    </div>
                                    <div>
                                        <BodyText weight='bold'>Estimated end date: </BodyText>
                                        <OtherText>{singleDBTask?.estimatedEndDate ?
                                            (formatDateForDisplay(singleDBTask?.estimatedEndDate) + ' ' + getTimeFromDate(singleDBTask?.estimatedEndDate))
                                            : '-'}</OtherText>
                                    </div>
                                </Flex>
                            </DBTaskGridCard>
                            <DBTaskGridCard>
                                <BodyText weight='bold'>Actual Time</BodyText>
                                <Separator />
                                <Flex gap='10px' column between >
                                    <div>
                                        <BodyText weight='bold'>Actual start date: </BodyText>
                                        <OtherText>{singleDBTask?.actualStartDate ?
                                            (formatDateForDisplay(singleDBTask?.actualStartDate) + ' ' + getTimeFromDate(singleDBTask?.actualStartDate))
                                            : '-'} </OtherText>
                                    </div>
                                    <div>
                                        <BodyText weight='bold'>Actual end date: </BodyText>
                                        <OtherText>{singleDBTask?.actualEndDate ?
                                            (formatDateForDisplay(singleDBTask?.actualEndDate) + ' ' + getTimeFromDate(singleDBTask?.actualEndDate))
                                            : '-'}</OtherText>
                                    </div>
                                </Flex>
                            </DBTaskGridCard>
                            <DBTaskGridCard>
                                <BodyText weight='bold'>Cost</BodyText>
                                <Separator />
                                <Flex column height='calc(100% - 53px)' between >
                                    <Flex width='100%' between >
                                        <BodyText >Estimated: </BodyText>
                                        <OtherText>
                                            {singleDBTask?.estimatedCost ? ('GH₵' + singleDBTask?.estimatedCost.toFixed(2)) : '-'}
                                        </OtherText>
                                    </Flex>
                                    <Flex width='100%' between >
                                        <BodyText >Actual: </BodyText>
                                        <OtherText>
                                            {singleDBTask?.actualCost ? ('GH₵' + singleDBTask?.actualCost.toFixed(2)) : '-'}
                                        </OtherText>
                                    </Flex>
                                    <Flex width='100%' between >
                                        <BodyText weight='bold'>Difference:</BodyText>
                                        {singleDBTask?.cycleInfo ? <OtherText>-</OtherText> : <OtherText
                                            color={
                                                singleDBTask?.actualCost < singleDBTask?.estimatedCost ? '#00B04C' : '#f00'
                                            }
                                        >
                                            {singleDBTask?.costDifference ? 'GH₵' + (singleDBTask?.costDifference.toFixed(2)) : '-'}
                                        </OtherText>}
                                    </Flex>
                                </Flex>
                            </DBTaskGridCard>
                            <DBTaskGridCard>
                                <BodyText weight='bold'>Duration</BodyText>
                                <Separator />
                                <Flex gap='10px' column between >
                                    <Flex width='100%' between >
                                        <BodyText >Estimated: </BodyText>
                                        <OtherText>
                                            {singleDBTask?.estimatedDuration ? getTime(singleDBTask?.estimatedDuration) : '-'}
                                        </OtherText>
                                    </Flex>
                                    <Flex width='100%' between >
                                        <BodyText >Actual: </BodyText>
                                        <OtherText>
                                            {singleDBTask?.totalDuration ? getTime(singleDBTask?.totalDuration) : '-'}
                                        </OtherText>
                                    </Flex>
                                    <Flex width='100%' between >
                                        <BodyText weight='bold'>Difference:</BodyText>
                                        {singleDBTask?.cycleInfo ? <OtherText>-</OtherText> : <OtherText
                                            color={
                                                singleDBTask?.estimatedDuration >= singleDBTask?.totalDuration ? '#00B04C' : '#f00'
                                            }
                                        > {singleDBTask?.durationDifference ? getTime(singleDBTask?.durationDifference) : '-'
                                            }</OtherText>}
                                    </Flex>
                                </Flex>
                            </DBTaskGridCard>
                        </DBTaskGrid>
                    </DBSingleTaskSection>
                    <DBSingleTaskSection style={{ width: '40%' }} >
                        <TitleText weight='bold'>Task Timeline</TitleText>
                        <Flex column mt='20' >
                            {singleDBTask?.userTasks.map((ut, i) => <TimelineItem ifFirst={i == 0} key={ut.id} handleImages={handleImages} data={ut} />)}
                        </Flex>
                    </DBSingleTaskSection>
                </DBSingleTaskContainer>
            </PageWrapper>
        </Animation>
        {imagesModal.open && <ImagesSlider details={imagesModal.details} images={imagesModal.images} setImagesModal={setImagesModal} />}
    </>
}